<ng-container *ngIf="reservation != null">
    <tr class="reservation" [class]="statusToClass(reservation.reservationDetails.reservationsStatus)">
        <!-- status -->
        <td [canRead]="'Status'" class="td-status-c td-status" data-bs-toggle="collapse" data-bs-target>
            <div>
                <a class="reservation-status" href="javascript:void(0);" (click)="onShowChangeStatusModal($event)">
                    <img
                        [attr.src]="'assets/images/' + statusToIcon(reservation.reservationDetails.reservationsStatus)">
                </a>
            </div>
        </td>
        <td class="td-customer-c td-tags">
            <div>
                <!-- customer type -->
                <!-- <label [canRead]="'Type'" *ngIf="reservation.reservationDetails.reservationType != 'S'"
                    class="customer-type"
                    [attr.style]="'background-color: ' + getCustomerTypeColor(reservation.reservationDetails.reservationType) + ';color: ' + getCustomerTypeTextColor(reservation.reservationDetails.reservationType)">{{wrapCustomerType(reservation.reservationDetails.reservationType)}}</label> -->

                <div class="customer-tags">
                    <label [canRead]="'Type'" *ngIf="(reservation.customerDetails.customerType ?? reservation.reservationDetails.reservationType) != 'S'"
                        class="customer-type-c"
                        [attr.style]="'background-color: ' + getCustomerTypeColor(reservation.customerDetails.customerType ?? reservation.reservationDetails.reservationType)">
                        {{reservation.customerDetails.customerType ?? reservation.reservationDetails.reservationType}}
                    </label>
                    <div [canRead]="'Tags'" class="btn-tag-group">
                        <label *ngFor="let tag of uniqueCustomerTagsByCategory" class="btn-tag-static btn-tag-static-sm"
                            [style.backgroundColor]="getTagColor(tag)">
                        </label>
                    </div>
                    <small *ngIf="isPending()" class="badge-pending">!</small>

                    <!-- discount -->
                    <small [canRead]="'Discount'"
                        *ngIf="hasDiscount()"
                        class="badge-discount">-{{reservation.reservationDetails.discount}}%</small>

                    <!-- bill -->
                    <small [canRead]="'Bill'"
                        *ngIf="reservation.reservationDetails.bill != null && reservation.reservationDetails.bill > 0"
                        class="badge-bill">&euro;&euro;</small>

                    <img [canRead]="'Bill'" class="badge-credit-card"
                        *ngIf="(reservation.reservationDetails?.bill == null || reservation.reservationDetails.bill <= 0) && reservation.reservationDetails.tokenization"
                        src="assets/images/credit-card.png">
                </div>

                <!-- customer name -->
                <div class="customer-surname-container flex-font">
                    <span [canRead]="'FullName'" class="customer-surname">
                        <span
                            *ngIf="reservation.customerDetails.surname != null && reservation.customerDetails.surname.length > 0">
                            {{reservation.customerDetails.surname}}
                        </span>
                        <span
                            *ngIf="reservation.customerDetails.surname != null && reservation.customerDetails.surname.length > 0 && reservation.customerDetails.name != null && reservation.customerDetails.name.length > 0">
                            {{(reservation.customerDetails.name)[0]}}.
                        </span>
                        <span
                            *ngIf="(reservation.customerDetails.surname == null || reservation.customerDetails.surname.length <= 0) && reservation.customerDetails.name != null && reservation.customerDetails.name.length > 0">
                            {{reservation.customerDetails.name}}
                        </span>
                    </span>
                    <span
                        *ngIf="reservation.reservationDetails.walkIn && (reservation.customerDetails.surname == null || reservation.customerDetails.surname.length <= 0) && (reservation.customerDetails.name == null || reservation.customerDetails.name.length <= 0)">
                        {{ 'reservations.list.walkIn' | translate }}
                    </span>
                </div>

            </div>
        </td>
        <!-- covers -->
        <td [canRead]="'Covers'" class="td-covers-c flex-font">
            <div>
                <span class="reservation-covers">
                    {{reservation.reservationDetails.covers}}p
                </span>
            </div>
        </td>
        <!-- arrival time -->
        <td [canRead]="'ArrivalDateTime'" class="td-arrival-time-c flex-font">
            <div>
                <span>{{reservation.reservationDetails.arrivalTime |
                    amDateFormat:'HH:mm'}}
                </span>
            </div>
        </td>
        <!-- table -->
        <td [canRead]="'Table'" class="td-table-c flex-font">
            <div>
                <span class="reservation-table d-flex flex-column justify-content-center align-items-center">
                    @if ((restaurantHasOnlineCategories$ | async)) {
                        <span
                            *ngIf="reservation.reservationDetails.onlineCategory != null"
                            class="table-category text-white px-2 py-0.5 rounded"
                            [class.compact]="reservation.reservationDetails.allocatedTables != null && reservation.reservationDetails.allocatedTables.length > 0"
                            [style.backgroundColor]="reservation.reservationDetails.onlineCategory.iconColor">
                            {{reservation.reservationDetails.onlineCategory.iconCaption}}
                        </span>
                    }
                    <span>{{reservation.reservationDetails.allocatedTables | allocatedTableNames:2}}&nbsp;</span>
                </span>&nbsp;
            </div>
        </td>
        <!-- notes -->
        <td [canRead]="'Notes'" class="td-notes-c flex-font">
            <div>
                <span class="reservation-notes">{{getSourceCaption()}} <span *ngIf="reservation.reservationDetails.roomNumber" [canWrite]="'SearchByRoomNum'">[{{'reservations.roomAbbreviation' | translate}} {{reservation.reservationDetails.roomNumber}}]</span> {{reservation.reservationDetails.notes}}</span>
            </div>
        </td>
        <!-- extra info -->
        <td [canRead]="'FixMenu'" *ngIf="restaurantHasExtraInfo" class="td-extra-info-c text-center flex-font">
            <div>
                {{reservation.reservationDetails.extraInfo}}
            </div>

        </td>
        <!-- info -->
        <td class="td-info-c td-tags">
            <div>
                <div class="btn-tag-group mt-md-1">
                    <!-- <label *ngFor="let allergy of allergies" class="btn-tag-static btn-tag-static-sm bg-green">
                        <span>{{allergy}}</span>
                    </label> -->
                    <img [canRead]="'Allergies'"
                        *ngIf="(reservation.reservationDetails?.allergy != null && reservation.reservationDetails?.allergy != '') || dietaryTags.length > 0 || allergies.length > 0"
                        src="assets/images/icon_allergies.png" class="icon-dietary">
                    <ng-container *ngIf="showTags">
                        <div class="tags">
                            <!-- <label [canRead]="'Tags'" *ngFor="let tag of uniqueReservationTagsByCategory"
                                class="btn-tag-static btn-tag-static-sm" [style.backgroundColor]="getTagColor(tag)">
                                <span>{{tag.title}}</span>
                            </label> -->
                            <app-tag-icon [canRead]="'Tags'" *ngFor="let tag of uniqueReservationTagsByCategory"
                                [color]="getTagColor(tag)" class="tag"></app-tag-icon>
                        </div>
                    </ng-container>
                </div>
                <div class="btn-tag-group mt-md-1">
                    <img [canRead]="'SmokingArea'" *ngIf="reservation.reservationDetails?.smokingArea == true"
                        src="assets/images/smoking.png">
                    <img [canRead]="'Cake'" *ngIf="reservation.reservationDetails?.hasCake == true"
                        src="assets/images/icon_cake.png">
                    <ng-container *ngIf="!restaurantHasExtraInfo">
                        <img [canRead]="'FixMenu'" *ngIf="reservation.reservationDetails?.fixMenu == true"
                            src="assets/images/fix-menu.png">
                    </ng-container>
                <ng-container *ngIf="hasMetadata(reservation.reservationDetails?.metadata)">
                    <span class="pms-info-indicator" [attr.title]="'reservations.customerDetails.pmsInfo' | translate"
                        [attr.aria-label]="'reservations.customerDetails.pmsInfo' | translate">
                        i
                    </span>
                </ng-container>
                    <img [canRead]="'PreOrder'" *ngIf="reservation.reservationDetails?.preorder == true"
                        src="assets/images/preorder.png">
                </div>
                <i [canRead]="'Purpose'" *ngIf="reservation.reservationDetails.purpose === 'Drink'"
                    class="ihost-icon-drink"></i>
                <!-- <i [canRead]="'Purpose'" *ngIf="reservation.reservationDetails.purpose === 'Food'"
                    class="ihost-icon-food"></i> -->

                <div class="td-source" [canRead]="'Source'">
                    @if (reservation.sourceDetails?.sourceType == 'REFERENCE') {
                        <img src="assets/images/ref.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'WEBSITE') {
                        <img src="assets/images/web.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'FACEBOOK') {
                        <img src="assets/images/fb.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'MHOSPITALITY') {
                        <img src="assets/images/mobile-app.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'GOOGLE') {
                        <img src="assets/images/google.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'INSTAGRAM') {
                        <img src="assets/images/insta.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'TRIP_ADVISOR') {
                        <img src="assets/images/trip_advisor.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'RESY') {
                        <img src="assets/images/resy.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'GODINING' || reservation.sourceDetails?.sourceCategory == 'GODINING') {
                        <img src="assets/images/go.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'MICHELIN') {
                        <img src="assets/images/michelin.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'AROUNDTHETABLE') {
                        <img src="assets/images/around_the_table.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'TRIPAROUND') {
                        <img src="assets/images/triparound.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'THELIST') {
                        <img src="assets/images/the_list.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'TOPTOWN') {
                        <img src="assets/images/toptown.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'DINEATHENS') {
                        <img src="assets/images/dine-athens.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'VIP1') {
                        <img src="assets/images/vip.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'PARTNERS1') {
                        <img src="assets/images/partners.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'TIKTOK') {
                        <img src="assets/images/tiktok.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'TOURMIE') {
                        <img src="assets/images/tourmie.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'EXCLUSIVI') {
                        <img src="assets/images/exclusivi.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'INHOUSE') {
                        <img src="assets/images/inhouse.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'GUESTS') {
                        <img src="assets/images/guest.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'INFOTOUCH') {
                        <img src="assets/images/infotouch.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'CAMPAIGN') {
                        <img src="assets/images/campaign.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'MEMBERS') {
                        <img src="assets/images/members.png">
                    } @else if (reservation.sourceDetails?.sourceType == 'GLAMBERS') {
                        <img src="assets/images/glambers.png">
                    } @else if (reservation.sourceDetails?.sourceCategory == 'EB2CPLATFORM' && reservation.sourceDetails?.sourceType != null) {
                        <!-- unknown sources -->
                        <span class="badge-unknown-source">{{reservation.sourceDetails?.sourceType | unknownSource}}</span>
                    }

                </div>
            </div>
        </td>
        <!-- phone -->
        <td [canRead]="'Telephone'" class="td-phone-c flex-font">
            <div>
                <a [href]="'tel:' + reservation.customerDetails.telephone">{{reservation.customerDetails.telephone
                    | formatPhone}}</a>
            </div>

        </td>
        <td *ngIf="!showGlobalSearchInfo" class="td-actions w-1p"
            [routerLink]="['/reservations/edit/' + (reservation.reservationDetails.reservationId ?? reservation.reservationDetails.tmpId)]">
            <a class="btn-dots" href="javascript:void(0);"><i class="icon-dots"></i>
            </a>
        </td>
    </tr>
    <tr class="details" [class]="statusToClass(reservation.reservationDetails.reservationsStatus)">
        <td colspan="10">
            <div [attr.id]="'tr-' + index" #reservationdetails class="reservation-details collapse"
                [class.show]="isExpanded">
                <div class="px-3 pb-3" [hidden]="!showReservationDetails">
                    <hr class="mt-0">
                    <div class="btn-tag-group flex-wrap mb-n1">
                        <div class="d-flex flex-column">
                            <!-- reservation tags -->
                            <div *ngIf="showReservationTagsOnDetails()" class="d-flex mb-2">
                                <label class="fixed-width flex-font">{{ 'reservations.reservationTags' | translate }}: </label>
                                <div class="d-flex align-items-center flex-wrap ms-2">
                                    <label [canRead]="'Allergies'" *ngFor="let allergy of reservationAllergies"
                                        class="btn-tag-static btn-tag-static-sm bg-green">
                                        <span class="flex-font">{{allergy}}</span>
                                    </label>
                                    <label [canRead]="'Tags'" *ngFor="let tag of reservationTags"
                                        class="btn-tag-static btn-tag-static-sm"
                                        [style.backgroundColor]="getTagColor(tag)">
                                        <span class="flex-font">{{tag.title}}</span>
                                    </label>
                                </div>
                            </div>
                            <!-- customer tags -->
                            <div *ngIf="showCustomerTagsOnDetails()" class="d-flex">
                                <label class="fixed-width flex-font">{{ 'reservations.customerTags' | translate }}: </label>
                                <div class="d-flex align-items-center flex-wrap ms-2">
                                    <label [canRead]="'Allergies'" *ngFor="let allergy of customerAllergies"
                                        class="btn-tag-static btn-tag-static-sm bg-green">
                                        <span class="flex-font">{{allergy}}</span>
                                    </label>
                                    <label [canRead]="'Tags'" *ngFor="let tag of customerTags"
                                        class="btn-tag-static btn-tag-static-sm"
                                        [style.backgroundColor]="getTagColor(tag)">
                                        <span class="flex-font">{{tag.title}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- <label *ngIf="reservation.reservationDetails.smokingArea == true"
                            class="btn-tag-static btn-tag-static-sm bg-purple">
                            <span>{{ 'tags.smoking' | translate }}</span>
                        </label> -->
                        <!-- <label class="btn-tag-static btn-tag-static-sm bg-green">
                            <span>Allergy: Nuts</span>
                        </label>
                        <label class="btn-tag-static btn-tag-static-sm bg-green">
                            <span>Diet: Vegan</span>
                        </label>
                        <label class="btn-tag-static btn-tag-static-sm bg-teal">
                            <span>Anniversary</span>
                        </label>
                        <label class="btn-tag-static btn-tag-static-sm bg-purple">
                            <span>Smoking</span>
                        </label> -->
                    </div>
                    <div class="extra-info mt-4 flex-font">
                        <ng-container
                            *ngIf="reservation.customerDetails.telephone != null && reservation.customerDetails.telephone.length > 0">
                            <label [canRead]="'Telephone'">{{'common.phone' | translate}}</label>&nbsp;
                            <a [canRead]="'Telephone'"
                                [href]="'tel:' + reservation.customerDetails.telephone">{{reservation.customerDetails.telephone
                                | formatPhone}}</a>
                        </ng-container>
                        
                        <ng-container
                            *ngIf="reservation.reservationDetails.bill != null && reservation.reservationDetails.bill > 0">
                            <br>
                            <label [canRead]="'Bill'">{{'common.bill' | translate}}</label>&nbsp;
                            <strong [canRead]="'Bill'">{{reservation.reservationDetails.bill}}
                                <span class="text-xs"> EUR</span>
                            </strong>
                        </ng-container>
                       
                        <ng-container
                            *ngIf="hasDiscount()">
                             <br>
                            <label [canRead]="'Discount'">{{'common.discount' | translate}}</label>&nbsp;
                            <strong [canRead]="'Discount'">{{reservation.reservationDetails.discount}}%</strong>
                        </ng-container>
                        
                        <ng-container *ngIf="hasSource(reservation)">
                            <br>
                            <label [canRead]="'Source'">{{'common.source' | translate}}</label>&nbsp;
                            <strong [canRead]="'Source'">{{getSourceDesctiption(reservation.sourceDetails!)}}</strong>
                        </ng-container>

                        <p [canRead]="'FixMenu'"
                            *ngIf="restaurantHasExtraInfo && showExtraInfo(reservation.reservationDetails.extraInfo)"
                            class="text-faded">
                            {{reservation.reservationDetails.extraInfo}}</p>

                        <p *ngIf="reservation.reservationDetails.roomNumber" [canWrite]="'SearchByRoomNum'" class="text-faded">{{'reservations.roomAbbreviation' | translate}} {{reservation.reservationDetails.roomNumber}}</p>
                      

                        <div *ngIf="getMetadataEntries(reservation.reservationDetails.metadata).length > 0"
                            class="reservation-metadata text-xs">
                            <div *ngFor="let entry of getMetadataEntries(reservation.reservationDetails.metadata)"
                                class="reservation-metadata-row">
                                <span class="reservation-metadata-label">
                                    {{ getMetadataCaption(entry) }}:
                                </span>

                                <ng-container *ngIf="splitMetadataValue(entry.value).length > 1; else singleListMetadataValue">
                                    <span *ngFor="let item of splitMetadataValue(entry.value)"
                                        class="reservation-metadata-badge badge bg-light text-dark me-1">
                                        {{ item }}
                                    </span>
                                </ng-container>

                                <ng-template #singleListMetadataValue>
                                    <span class="reservation-metadata-value">{{ entry.value }}</span>
                                </ng-template>
                            </div>
                        </div>
                        <br>
                        <p [canRead]="'Notes'" class="text-faded">{{reservation.reservationDetails.notes}}</p>

                        <p [canRead]="'PreOrder'"
                           *ngIf="reservation.reservationDetails.preorder">
                            <button class="see-order-btn btn btn-xs btn-main"
                                    (click)="showOrderDetails()">
                                    {{ 'orderDetails.orderDetails' | translate }}
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</ng-container>